<template>
    <section class="what-we-do">

  <div class="container">
      <div class="section-title">
          <label>{{ data.title}}</label>
          <span>{{data.title}}</span>
        <p>{{ data.paragraph }}</p>
      </div>
      <div class="row">
        <div class="col-lg-5 col-12 float-start">
       <div class="img"
          :style="{
            'background-image': `url(${ require(`@/assets/${data.imagePath}`)})`,
          }"
        >
        </div>
        </div>
        <div class="col-lg-7 col-12 float-start" >
          <div class="desc">
            
              <div class="logo">
                <img :src="require(`@/assets/images/logo.png`)" />
              </div>
            
            <div v-html="data.caption"></div>
          </div>
        </div>
      </div>
  </div>
    </section>

</template>
<script>

export default {
 props:{
   data:{
     type:Object,
   }
 }
};
</script>


<style scoped>
.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.what-we-do {
  background: #fff;
  width: 100%;
}

.what-we-do .img {
  width: 100%;
  height: 300px;
  border-radius: 20px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

}

.what-we-do .desc {
  padding: 20px;
  min-height: 300px;
  background: #fff;
  border: #eaeaea solid 1px;
  border-radius: 20px;
  display: inline-block;
  margin-right: -200px;
  margin-top: 50px;
}

.desc .logo {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  text-align: center;
  margin: 0 auto;
  background-color: #fff;
  border: #eaeaea solid 1px;
  margin-top:-70px; 
  margin-bottom: 20px;
  padding-top:25px;
}

.desc .logo img {
  max-width: 70px;
}


@media (max-width: 1024px) {
  .what-we-do .desc {
    margin-top: 0px;
    margin-right: 0px;
    right: unset;
    min-height: unset;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    background: unset;
    border: unset;
    text-align: justify;
  }
}

.section-titles {
  float: left;
  width: 100%;
  position: relative;
}

.section-title,
.section-title label,
.section-title span {
  text-align: center;
  width: 100%;
  height: 70px;
}

.section-title label {
  font-size: 30px;
  margin: 0;
  color: #ebc75d;
  z-index: 1;
  position: relative;
}

.section-title span {
  font-size: 50px;
  opacity: 0.5;
  color: #f1f1f1;
  margin-top: -80px;
  z-index: 0;
  display: block;
}

@media screen and (max-width: 700px) {
   .what-we-do .img {
  width: 100%;
  height: 200px;
  border-radius: 20px;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;

}

} 

</style>
